// extracted by mini-css-extract-plugin
export var timerIcon = "TimerIcon-module__timerIcon___n6mNX";
export var timerIconLarge = "TimerIcon-module__timerIconLarge___Hc9a-";
export var timerIconSmall = "TimerIcon-module__timerIconSmall___-YnhV";